(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .directive('tfcColorSwatch', tfcColorSwatch);

  function tfcColorSwatch(){
    return {
      restrict: 'E',
      replace: true,
      scope: {
        reportKeys: '=data',
        lastVisible: '='
      },
      templateUrl: 'Util/ColorSwatch/ColorSwatch.tmpl.html'
    }
  }

})();